/**
*
* PartsForm
*
*/

import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { compose } from 'redux';

import { makeSelectEntities } from 'models/selectors';
import { makeSelectCurrentRegionId, makeSelectMainDomain, makeSelectCurrentDomain } from 'containers/App/selectors';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';
import { partsDealerChange, partsDealerOpenDropDown } from 'containers/App/metricsActions'
import {
  Field, reduxForm, change as formChange
} from 'redux-form/immutable';
import PrimaryField from 'components/Form/components/PrimaryField';
import RFReactSelect from 'components/Form/components/RFReactSelect';
import Button from 'components/Button';
import { partsSearch } from './actions';
import * as metricsActions from 'containers/App/metricsActions'

import 'css/components/parts-search.sass';

import { parse } from 'qs';


const validate = (values) => {
  const errors = {};
  if (!values.get('query')) {
    errors.query = 'Название детали не может быть пустым';
  }
  return errors;
};

const DealerSelector = ({
  isMain, domain, dealerOptions, onDealerChange, dealerError, partsDealerOpenDropDown
}) => {
  if (isMain || domain.isCG) {
    return (
      <div className="parts-search__dealer">
        <div className="parts-search__dealer-icon">
          <FontAwesomeIcon icon={faMapMarkerAlt} style={{width: 12}}/>
        </div>
        <div className="parts-search__dealer-input">
          <Field name="dealerId" component={RFReactSelect} onMenuOpen={partsDealerOpenDropDown} allowBlank={false} error={dealerError} onHome={true} placeholder="Все дилеры" options={[{ label: 'Все дилеры', value: 0 }].concat(dealerOptions)} onChange={onDealerChange} />
          {dealerError && <div className="parts-search__dealer-error">Выберите дилера</div>}
        </div>
      </div>
    );
  }
  return null;
};

class PartsForm extends React.PureComponent { // eslint-disable-line react/prefer-stateless-function
  constructor (props) {
    super(props);
    this.searchRef = React.createRef()  

    this.onSubmit = this.onSubmit.bind(this);
    this.onDealerChange = this.onDealerChange.bind(this);
  }

  componentDidMount() {
    let predefinedProduct = null
    try {
      const { location, change } = this.props
      const query = parse(location.search.substr(1)); // eslint-disable-line no-restricted-globals
      predefinedProduct = query.product
      if(!predefinedProduct) return
      const y = this.searchRef.current.getBoundingClientRect().top + window.pageYOffset - 100;
      setTimeout(() => window.scrollTo({left: 0, top: y, behavior: 'smooth'}), 10)
      // this.searchRef.current.scrollIntoView()
      change('query', predefinedProduct)
      return new Promise((resolve, reject) => {
        this.props.partsSearch({ data: {query: predefinedProduct}, resolve, reject });
      }).catch(() => {});

    } catch(e) {
      console.log(e)
    }
  }

  onSubmit (data) {
    const { pageData, sendRaw } = this.props
    const { podbor } = pageData
    return new Promise((resolve, reject) => {
      this.props.partsSearch({ data: data.toJS(), resolve, reject });
      const vals = data.toJS()
      sendRaw('PartsPage', 'btn_click_search', vals.query)
      // this.props.setForm('query', ' ')
    }).then(item => podbor && this.props.addToPodbor(item)).catch((item) => this.props.addToPodbor(item));
  }

  onDealerChange (e) {
    this.props.setDealerError(false)
    this.props.partsDealerChange({ e: e })
  }

  render () {
    const {
      handleSubmit, submitting, dealers, regions, regionId, isMain, domain, dealerError, pageData, partsDealerOpenDropDown, sendRaw
    } = this.props;
    let filteredDealers = Object.values(dealers);
    if (regionId && regions && regions[regionId]) {
      filteredDealers = filteredDealers.filter((one) => regions[regionId].cities.includes(one.cityId));
    }
    const dealerOptions = filteredDealers.filter(one => one.status).sort((a, b) => a.name.toLowerCase() >= b.name.toLowerCase() ? 1 : -1).map((one) => ({ label: one.name, value: one.id }));
    return (
      <form className="parts-search-form" onSubmit={handleSubmit(this.onSubmit)}>
        <div className="parts-search" ref={this.searchRef}>
          <div className="parts-search__query">
            <Field type="text" 
              icon={() => <FontAwesomeIcon icon={faSearch} />} 
              name="query" 
              component={PrimaryField} 
              label="Артикул" 
              placeholder={"Введите артикул или название детали"}
              onFocus={() => sendRaw('PartsPage', 'click_search_bar')}
              onChange={(a) => sendRaw('PartsPage', 'input_detail', a.target.value)}
            />
          </div>
          <DealerSelector isMain={isMain} partsDealerOpenDropDown={partsDealerOpenDropDown} dealerError={dealerError} domain={domain} dealerOptions={dealerOptions} onDealerChange={this.onDealerChange} />
          <div className="parts-search__submit">
            <Button loading={submitting} type="submit">
              Поиск
            </Button>
          </div>
        </div>
      </form>
    );
  }
}

PartsForm.propTypes = {

};

const mapStateToProps = createStructuredSelector({
  dealers: makeSelectEntities('dealers'),
  regions: makeSelectEntities('regions'),
  regionId: makeSelectCurrentRegionId(),
  isMain: makeSelectMainDomain(),
  domain: makeSelectCurrentDomain(),
  location: state => state.getIn(['router', 'location']).toJS()
});

function mapDispatchToProps (dispatch) {
  return {
    partsSearch: (payload) => dispatch(partsSearch(payload)),
    setForm: (name, value) => dispatch(formChange('parts-form', name, value)),
    partsDealerChange: (payload) => dispatch(partsDealerChange(payload)),
    partsDealerOpenDropDown: (payload) => dispatch(partsDealerOpenDropDown(payload)),
    sendRaw: (c, a, l) => dispatch(metricsActions.sendRaw(c, a, l))
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

const withForm = reduxForm({ form: 'parts-form', validate });

export default compose(
  withConnect,
  withForm,
)(PartsForm);
